export default __webpack_public_path__ + "static/media/Poppins-Black.88452d4e.svg";